import { render } from "./RateCategoryTable.vue?vue&type=template&id=58c58e28&scoped=true"
import script from "./RateCategoryTable.vue?vue&type=script&lang=js"
export * from "./RateCategoryTable.vue?vue&type=script&lang=js"

import "./RateCategoryTable.vue?vue&type=style&index=0&id=58c58e28&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c58e28"]])

export default __exports__